export const CloseIcon = {
  data: `<svg viewBox="0 0 384 512">
  <path d="M323.1 163.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L192 227.3 94.9 130.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L158.1 256 61 353.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L192 284.7l97.1 97.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L225.9 256 323.1 163.1z"/>
</svg> `,
  name: "close-icon" as const,
};
